import React, { useState } from 'react';

const initialForm = {
  name: '',
  category: 'medicacion',
  stock_count: 0,
  minimum_stock: 0,
  unit_label: 'unidades',
  expiration_date: '',
  notes: '',
  photo: null,
};

export const ClinicInventoryPanel = ({ workspace, onCreateInventory, onQuickAdjust, saving }) => {
  const [form, setForm] = useState(initialForm);

  const submit = async (event) => {
    event.preventDefault();
    const success = await onCreateInventory(form);
    if (success) setForm(initialForm);
  };

  return (
    <section className="grid gap-5 xl:grid-cols-[0.9fr_1.1fr]" data-testid="clinic-inventory-panel">
      <form onSubmit={submit} className="rounded-[28px] border border-white/60 bg-white/95 p-6 shadow-[0_20px_60px_rgba(15,23,42,0.08)]" data-testid="clinic-inventory-form">
        <p className="text-xs uppercase tracking-[0.24em] text-[#0f766e]">Alta rápida</p>
        <h2 className="mt-2 text-2xl font-black text-slate-900">Nuevo producto</h2>
        <div className="mt-5 space-y-4">
          <input data-testid="clinic-inventory-name-input" className="w-full rounded-2xl border border-slate-200 px-4 py-3" placeholder="Nombre del producto" value={form.name} onChange={(event) => setForm((prev) => ({ ...prev, name: event.target.value }))} required />
          <div className="grid gap-4 sm:grid-cols-2">
            <select data-testid="clinic-inventory-category-select" className="rounded-2xl border border-slate-200 px-4 py-3" value={form.category} onChange={(event) => setForm((prev) => ({ ...prev, category: event.target.value }))}>
              {workspace.inventory_categories.map((category) => <option key={category} value={category}>{category}</option>)}
            </select>
            <input data-testid="clinic-inventory-expiration-input" type="date" className="rounded-2xl border border-slate-200 px-4 py-3" value={form.expiration_date} onChange={(event) => setForm((prev) => ({ ...prev, expiration_date: event.target.value }))} />
          </div>
          <div className="grid gap-4 sm:grid-cols-3">
            <input data-testid="clinic-inventory-stock-input" type="number" min="0" className="rounded-2xl border border-slate-200 px-4 py-3" value={form.stock_count} onChange={(event) => setForm((prev) => ({ ...prev, stock_count: Number(event.target.value) }))} />
            <input data-testid="clinic-inventory-minimum-input" type="number" min="0" className="rounded-2xl border border-slate-200 px-4 py-3" value={form.minimum_stock} onChange={(event) => setForm((prev) => ({ ...prev, minimum_stock: Number(event.target.value) }))} />
            <input data-testid="clinic-inventory-unit-input" className="rounded-2xl border border-slate-200 px-4 py-3" value={form.unit_label} onChange={(event) => setForm((prev) => ({ ...prev, unit_label: event.target.value }))} />
          </div>
          <textarea data-testid="clinic-inventory-notes-input" className="min-h-[120px] w-full rounded-2xl border border-slate-200 px-4 py-3" placeholder="Notas rápidas" value={form.notes} onChange={(event) => setForm((prev) => ({ ...prev, notes: event.target.value }))} />
          <input data-testid="clinic-inventory-photo-input" type="file" accept="image/*" className="w-full rounded-2xl border border-dashed border-slate-300 px-4 py-3" onChange={(event) => setForm((prev) => ({ ...prev, photo: event.target.files?.[0] || null }))} />
          <button data-testid="clinic-inventory-submit-button" type="submit" className="w-full rounded-full bg-slate-900 px-5 py-3 text-sm font-semibold text-white transition hover:bg-slate-700" disabled={saving === 'inventory-create'}>
            {saving === 'inventory-create' ? 'Guardando…' : 'Guardar producto'}
          </button>
        </div>
      </form>

      <div className="space-y-4" data-testid="clinic-inventory-list">
        {workspace.inventory_items?.length ? workspace.inventory_items.map((item) => (
          <article key={item.id} className="rounded-[28px] border border-white/60 bg-white/95 p-5 shadow-[0_16px_40px_rgba(15,23,42,0.06)]" data-testid={`clinic-inventory-item-${item.id}`}>
            <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
              <div className="flex items-center gap-4">
                <div className="h-20 w-20 overflow-hidden rounded-[22px] bg-slate-100" data-testid={`clinic-inventory-photo-${item.id}`}>
                  {item.photo_url ? <img src={item.photo_url} alt={item.name} className="h-full w-full object-cover" /> : <div className="flex h-full items-center justify-center text-xs text-slate-400">Sin foto</div>}
                </div>
                <div>
                  <p className="text-lg font-bold text-slate-900" data-testid={`clinic-inventory-name-${item.id}`}>{item.name}</p>
                  <p className="text-sm text-slate-500">{item.category} · vence {item.expiration_date || 'sin fecha'}</p>
                  <p className="mt-2 text-sm font-semibold text-slate-700" data-testid={`clinic-inventory-stock-${item.id}`}>{item.stock_count} {item.unit_label}</p>
                </div>
              </div>
              <div className="flex flex-wrap gap-2">
                <button type="button" onClick={() => onQuickAdjust(item.id, item.stock_count + 1)} className="rounded-full bg-[#d1fae5] px-4 py-2 text-sm font-semibold text-[#065f46]" data-testid={`clinic-inventory-plus-${item.id}`}>+1</button>
                <button type="button" onClick={() => onQuickAdjust(item.id, Math.max(item.stock_count - 1, 0))} className="rounded-full bg-[#fee2e2] px-4 py-2 text-sm font-semibold text-[#991b1b]" data-testid={`clinic-inventory-minus-${item.id}`}>-1</button>
              </div>
            </div>
          </article>
        )) : <div className="rounded-[28px] border border-dashed border-slate-300 bg-white/80 p-8 text-sm text-slate-500" data-testid="clinic-inventory-empty">Todavía no hay productos cargados.</div>}
      </div>
    </section>
  );
};
